import * as React from 'react';
import { Select } from '../../../../../Passenger/components/Field/Select/Select';
import { Field, useFormState } from 'react-final-form';
import { PassengerFieldOption } from '../../../../../Passenger/types';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import { OrderDocumentType } from '@websky/graphql';

interface Props {
	everyPortPassengerIds?: string[];
	withEveryTravelServices?: boolean;
}

export const NAS_AND_TOURS_SINGLE_OPTION = 'nas&tours';

const DocumentsList: React.FC<Props> = ({ everyPortPassengerIds, withEveryTravelServices }) => {
	const { t } = useTranslation('FlightInfoCard');
	const theme = useTheme('FlightInfoCard').TicketsModal;

	const passengerId = useFormState().values?.['passengers'];

	const documentsList: PassengerFieldOption[] = React.useMemo(() => {
		const documentsList: PassengerFieldOption[] = [
			{
				key: OrderDocumentType.All,
				value: t('All documents')
			},
			{
				key: OrderDocumentType.ItineraryReceipt,
				value: t('Itinerary Receipt')
			}
		];

		const withEveryPortServices =
			(everyPortPassengerIds.length > 0 && passengerId === 'all') || everyPortPassengerIds.includes(passengerId);

		if (withEveryTravelServices && withEveryPortServices) {
			documentsList.push({
				key: NAS_AND_TOURS_SINGLE_OPTION,
				value: t('Airport Services & Tours')
			});
		} else if (withEveryPortServices) {
			documentsList.push({
				key: OrderDocumentType.NASTicket,
				value: t('Airport Services')
			});
		} else if (withEveryTravelServices) {
			documentsList.push({
				key: OrderDocumentType.EveryTravelTicket,
				value: t('Tours')
			});
		}

		return documentsList;
	}, [passengerId, everyPortPassengerIds, withEveryTravelServices]);

	return (
		<Field
			name="documents"
			defaultValue={OrderDocumentType.All}
			render={({ input }) => (
				<Select
					value={input.value}
					options={documentsList}
					name="documents"
					label=""
					onChange={input.onChange}
					onBlur={input.onBlur}
					className={theme.select}
				/>
			)}
		/>
	);
};

export default DocumentsList;
